import * as React from "react";
import { useEffect } from "react";
import {
    Form,
    Link,
    NavLink,
    useLoaderData,
    useSubmit,
} from "react-router-dom";
import { Button, Icon, Input } from "semantic-ui-react";
import { Contact } from "../../../stores/contact/contact-store";
import "./contacts.css";
import { RootStore } from "../../../stores/root-store";
import { TransportError } from "../../../stores/data-transporter";
import { AppState } from "../../../stores/app-mobx";

export async function loader(request: Request, rootStore: RootStore, appStore: AppState) {
    try {
        const url = new URL(request.url);
        const searchText = url.searchParams.get("suchfeld") || "";
        const rootStoreSession = rootStore.newSession();
        const contacts = await rootStoreSession.contactStore.loadAll();
        let contactsFinal: Contact[];
        appStore.setShowMap(false);

        contactsFinal = contacts
            .filter(
                (c) =>
                    c.firstName.toLowerCase().includes(searchText.toLowerCase()) ||
                    c.lastName.toLowerCase().includes(searchText.toLowerCase())
            )
            .sort((a, b) => {
                if (a.lastName > b.lastName) {
                    return 1;
                }
                return -1;
            });


        return { contacts: contactsFinal, searchText };
    } catch (error: TransportError) {
        throw new Response("", {
            status: error.statusCode,
            statusText: "Fehler beim Laden der Kontakte",
        });
    }
}

export default function Contacts(): JSX.Element {
    const { contacts, searchText } = useLoaderData() as {
        contacts: Contact[];
        searchText: string;
    };

    const submit = useSubmit();

    useEffect(() => {
        const searchField: HTMLFormElement | null = document.getElementById("search-field") as any;

        if (searchField !== null) {
            searchField.value = searchText;
        }
    }, [searchText]);

    return (
        <div className="contactsMain">
            <h1>Kontakte</h1>
            <Link to="neu">
                <Button type="submit" size="large">
                    Neuer Kontakt
                </Button>
            </Link>
            <Form role="search" className="contactList">
                <Input
                    id="search-field"
                    placeholder="Suche"
                    type="search"
                    name="suchfeld"
                    value={searchText}
                    icon={
                        <Icon
                            name="delete"
                            link
                            onClick={() => {
                                const input = document.getElementById(
                                    "search-field"
                                ) as HTMLInputElement;
                                input.value = "";
                                const form = document.getElementsByTagName("form")[0];
                                submit(form, {
                                    replace: searchText != null,
                                });
                            }}
                        />
                    }
                    onChange={(event) => {
                        submit(event.currentTarget.form, {
                            replace: searchText != null,
                        });
                    }}
                />
            </Form>
            <nav>
                <ul>
                    {contacts.map(c => (
                        <li key={c.id}>
                            <NavLink
                                to={`${c.id}`}
                                className={({ isActive, isPending }) =>
                                    isActive ? "active" : isPending ? "" : ""
                                }
                            >
                                {c.lastName}, {c.firstName}
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
    );
}
